import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Injectable, NgZone } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(
    private zone: NgZone,
    private snackBar: MatSnackBar,
    public translate: TranslateService
  ) {}

  public openSnackBar(
    message: string,
    action = 'OK',
    config?: MatSnackBarConfig,
    callback?: () => void
  ): void {
    this.zone.run(() => {
      let translateMessage = message;
      let translateButton = action;
      this.translate.stream(message || ' ').subscribe((res: string) => {
        translateMessage = res;
      });
      this.translate.stream(action || ' ').subscribe((res: string) => {
        translateButton = res;
      });
      const snackBar = this.snackBar.open(
        translateMessage,
        translateButton,
        config
          ? config
          : {
              verticalPosition: 'bottom',
              horizontalPosition: 'center',
              duration: 5000,
            }
      );
      snackBar.onAction().subscribe(() => {
        snackBar.dismiss();
        callback?.();
      });
    });
  }
}
